module.exports = __webpack_public_path__ + "img/avatar_random_14.f462b9e3.png";